module.exports = __webpack_public_path__ + "ge.2c8b97902e577829dd04.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/ge.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/ge.svg
// module chunks = styles